import React from 'react';
import DynamicForm from './dynamicForm';

/**
 * EditModal
 * @param {boolean} visible       - Whether modal is shown
 * @param {Object}  schema        - DynamicForm schema for editing
 * @param {Object}  initialData   - Initial data to populate the form
 * @param {Function} onClose      - Called when modal should close
 * @param {Function} onSubmit     - Called with form data on update
 */
export default function EditModal({ visible, schema, initialData, onClose, onSubmit }) {

    console.log('initialData:', initialData);

    if (!visible) return null;

    const handleAction = (action, data) => {
        if (action === 'cancel') onClose();
        if (action === 'update') onSubmit(data);
    };

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <div style={styles.header}>
                    <span style={styles.title}>Edit Details</span>
                    <button onClick={onClose} style={styles.closeButton}>
                        <span className="material-icons">close</span>
                    </button>
                </div>
                <div style={styles.modalBody}>
                    <DynamicForm
                        schema={schema}
                        mode="edit"
                        initialData={initialData}
                        onAction={handleAction}
                    />
                </div>
            </div>
        </div>
    );
}

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    modal: {
        background: '#fff',
        borderRadius: 8,
        width: '400px',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '16px',
        padding: '19px 24px',
        borderBottom: 'solid 1px #ccc'
    },
    modalBody: {
        padding: '24px'
    },
    title: {
        margin: 0,
        fontSize: '18px',
        color: '#333',
    },
    closeButton: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontSize: '24px',
        lineHeight: 1,
        color: '#555',
    },
};
